'use strict'

module.exports = [

	{name: 'gallery', groups: ['Článok', 'Obrázky'],
		sections: ['top', 'bottom', 'full', 'large'],
	},
	{name: 'image', groups: ['Článok', 'Obrázky'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'image-theme', groups: ['Obrázky'],
		sections: ['full', 'top'],
	},
	{name: 'image-rotator-header', groups: ['Obrázky'],
		sections: ['full', 'top'],
	},
	{name: 'image-mid', groups: ['Obrázky'],
		sections: ['full', 'top', 'large'],
	},
	{name: 'image-square', groups: ['Obrázky'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'image-banner', groups: ['Obrázky'],
		sections: ['full', 'large', 'top', 'bottom'],
	},
	{name: 'side-banner', groups: ['Obrázky'],
		sections: ['small'],
	},
	{name: 'multi-image', groups: ['Obrázky'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},
	{name: 'text-image', groups: ['Článok', 'Obrázky'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'image-rotator', groups: ['Článok', 'Obrázky'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'image-rotator-800x800', groups: ['Článok', 'Obrázky'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'hall-of-fame', groups: ['Obrázky'],
		sections: ['full', 'large'],
	},

]



//////////////////
// WEBPACK FOOTER
// ./src/blocks/_multi-images.js
// module id = 151
// module chunks = 0